<div class="user-info-main-wrap">
  <div class="user-info-title-wrap">
    <p class="user-info-title">
      LV Connect version {{sbmsVersion}}
    </p>
    <div class="shortcut-container">
      <button (click)="navigate()" class="link-button">Homepage</button>
      <button *ngFor="let item of customMenuItems" class="link-button" [routerLink]="item.routerLink">{{item.label}}</button>
      <p i18n>Welcome</p>
    </div>
  </div>


  <div class="user-info-user-name-box">
    <div class="user-info-username-button" (click)="menu.toggle($event)" *ngIf="userService.hasAnyRole(['admin', 'editor'])">
      <p class="user-info-user-name">
        {{userService.userName | titlecase}}
      </p>
    </div>
    <p-menu #menu [popup]="true" [model]="items"></p-menu>
    <div class="user-info-logout-box">
      <a (click)="logout()" class="user-info-logout">Logout</a>
    </div>
  </div>
</div>